<template>
  <div class="relative bg-[#00000008]">
    <LayoutsHeader/>
    <div class="lg:pt-16 pt-0 ">
        <slot/>
    </div>
    <LayoutsFooter/>
    <LayoutsMobToolbar/>
    <Cookie/>
    <AnalyticsYandex />
    <UiScrollTop />
  </div>
</template>